/**
 * @author      joseph.murphy@zumper.com (murph)
 * @copyright   Copyright (c) 2022, Zumper
 */

import { SystemStyleObject } from '@chakra-ui/theme-tools'

export const focus: SystemStyleObject = {
  outline: 'none',
  borderColor: 'neutral.500',
  boxShadow: 'outline',
}
